<div class="table-responsive" [ngClass]="{ 'oculto': dataSource.data.length<1 }">
    <table mat-table class="w-100" [dataSource]="dataSource" matSort>
        <!-- Nombre deudor -->
        <!-- Rut deudor -->
        <ng-container matColumnDef="name">
            <th
                mat-header-cell
                class="th-title"
                mat-sort-header
                *matHeaderCellDef>
                Deudor
            </th>
            <td mat-cell *matCellDef="let element" style="max-width: 250px;"
                class="td-text-content">
                <span>{{ element.name }}</span> <br >
                <span>{{ element.fullRut }}</span>
            </td>
        </ng-container>

        <!-- N Facturas compradas-->
        <ng-container matColumnDef="buyInvoices">
            <th
                mat-header-cell
                class="th-title"
                mat-sort-header
                *matHeaderCellDef>
                Total Facturas
            </th>
            <td mat-cell *matCellDef="let element"
                class="td-text-content">
                <span>{{ element.buyInvoices }}</span> <br >
                <span>{{ element.buyInvoiceTotalAmount | currency:'CLP':'symbol' }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="receivedCreditNotes">
            <th mat-header-cell class="th-title"
            mat-sort-header 
            *matHeaderCellDef
            >Total Notas Crédito
        </th>
        <td mat-cell *matCellDef="let element" class="td-text-content">
            <span>{{ element.receivedCreditNotes }}</span> <br >
            <span>{{ element.receivedCreditNotesTotalAmount | currency:'CLP':'symbol' }}</span>
        </td>
        </ng-container>

        <ng-container matColumnDef="resolutionStateName">
            <th
                mat-header-cell
                class="th-title"
                *matHeaderCellDef>
                Resolución
            </th>
            <td mat-cell *matCellDef="let element"
                class="td-text-content">
                <div *ngIf="canChangeResolution; else finalResolution">
                    <mat-button-toggle-group *ngIf="!isLoadingDebtor(element.companyId); else spinner"
                    [value]="element.resolutionState"
                     (change)="toggleDebtorResolutionChange($event, element.companyId, element.resolutionState)">
                        <mat-button-toggle [value]="3">
                            <fa-icon class="fa-red" [icon]="icons.faCircleXmark"></fa-icon>
                        </mat-button-toggle>
                        <mat-button-toggle [value]="0">
                            <fa-icon class="fa-grey" [icon]="icons.faCircleMinus"></fa-icon>
                        </mat-button-toggle>
                        <mat-button-toggle [value]="2">
                            <fa-icon class="fa-green" [icon]="icons.faCircleCheck"></fa-icon>
                        </mat-button-toggle>
                    </mat-button-toggle-group>    
                </div>
                <ng-template #spinner >
                    <mat-spinner [diameter]="30"></mat-spinner>
                  </ng-template>              
                <ng-template #finalResolution>
                    <span>{{ element.resolutionStateName }}</span>
                </ng-template>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>

        <!-- <tr tr
            *matRowDef="let row;columns: displayedColumns">
        </tr> -->
    </table>
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
</div>

<div *ngIf="dataSource.data.length<1">
    No se encontraron Deudores
</div>